<div class="logout-container">
  <div class="logout-message">
    <img src="../../../assets/img/NumenLogo3.png" alt="Logo" class="logout-logo" />
    <p>Vous avez bien été déconnecté.<br>Vous pouvez fermer cet onglet.</p>
  </div>
</div>
